import axios from 'axios';
import { getNonGwApiRoot } from '../../constants/ParamountReactConstants';
import { AsyncDispatch } from '../../../types/global';

export function fetchManualOverwrites() {
  return (dispatch: AsyncDispatch) => {
    return dispatch({
      type: 'FETCH_MANUAL_OVERWRITES',
      payload: axios.get(`${getNonGwApiRoot()}/dynamic_custom_field_manual_overwrites`),
    });
  };
}

export function addManualOverwrite(itemId: number, customFieldId: number) {
  return (dispatch: AsyncDispatch) => {
    return dispatch({
      type: 'ADD_MANUAL_OVERWRITE',
      payload: axios.post(`${getNonGwApiRoot()}/dynamic_custom_field_manual_overwrites`, {
        item_id: itemId,
        custom_field_id: customFieldId,
      }),
      meta: { itemId, customFieldId },
    });
  };
}

export function removeManualOverwrite(itemId: number, customFieldId: number) {
  return (dispatch: AsyncDispatch) => {
    return dispatch({
      type: 'REMOVE_MANUAL_OVERWRITE',
      payload: axios.delete(`${getNonGwApiRoot()}/dynamic_custom_field_manual_overwrites`, {
        data: {
          item_id: itemId,
          custom_field_id: customFieldId,
        },
      }),
      meta: { itemId, customFieldId },
    });
  };
}
